import '@webcomponents/webcomponentsjs/webcomponents-bundle.js';
import '@consultantplus/dropdown-select';
import '@consultantplus/date-dropdown';
import '@consultantplus/datepicker';
import 'core-js/features/object/assign';
import 'core-js/features/string/repeat';
import 'core-js/features/string/pad-start';
import 'core-js/features/string/pad-end';
import 'core-js/features/global-this';
import 'core-js/features/url-search-params';
import { CalcTools } from './calc-tools.js';

window.tools = CalcTools;

(function () {
    tools.setupArraySortBy();

    (function () {
        window.tooltipButtonClicked = function () {
            var $tooltipContent = $(this).closest('.tooltip-div').find('.tooltip-content');
            $tooltipContent.addClass('active');
            if (window.pageYOffset + window.innerHeight - $tooltipContent.innerHeight() < $(this).offset().top + 40) {
                $tooltipContent.addClass('display-top');
            } else {
                $tooltipContent.removeClass('display-top');
            }

            return false;
        };

        window.tooltipClose = function () {
            $(this).closest('.tooltip-content.active').removeClass('active');
            return false;
        };

        $('.tooltip-button').attr('tabindex', '-1').click(tooltipButtonClicked);

        $('.tooltip-content .close-button').click(tooltipClose);


        $(document).mousedown(function (e) {
            var container = $('.tooltip-content.active');
            if (container.length > 0) {
                if (!container.is(e.target) && !container.parent().find('.tooltip-button').is(e.target) && !container.parent().find('.tooltip-button > div').is(e.target) && (container.has(e.target).length === 0)) {
                    container.removeClass('active');
                }
            }
        });
    })();

    //focusing logic
    $(".tab-expandablerow-add").click((e) => {
        $(e.target).closest(".expandablerow").removeClass("expandablerow-focus");
        e.preventDefault();
    })
    .focus((e) => $(e.target).closest(".expandablerow").addClass("expandablerow-focus"))
    .blur((e) => $(e.target).closest(".expandablerow").removeClass("expandablerow-focus"));

    $(".dynamic-list-add-row button").mouseup((e) => {
        if(e.which == 1)
            $(e.target).blur();
    });
})();

//'find' polyfill
(function () {
    if (!Array.prototype.find) {
        Array.prototype.find = function (predicate) {
            if (this == null) {
                throw new TypeError('Array.prototype.find called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                return undefined
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return value;
                }
            }
            return undefined;
        };
    }
})();

//'at' polyfill
if (!Array.prototype.at) {
    Array.prototype.at = function(position) {
        if (this == null) {
            throw new TypeError('Array.prototype.at called on null or undefined');
        }
        var array = this;
        var index = position >= 0 ? position : array.length + position
        return array[index];
    };
}

// Some jquery patches...
(function ($) {
    // Behind the scenes method deals with browser
    // idiosyncrasies and such
    $.caretTo = function (el, index) {
        if (el.createTextRange) {
            var range = el.createTextRange();
            range.move("character", index);
            range.select();
        } else if (el.selectionStart !== null) {
            el.focus();
            el.setSelectionRange(index, index);
        }
    };

    // The following methods are queued under fx for more
    // flexibility when combining with $.fn.delay() and
    // jQuery effects.

    // Set caret to a particular index
    $.fn.caretTo = function (index, offset) {
        return this.queue(function (next) {
            if (isNaN(index)) {
                var i = $(this).val().indexOf(index);

                if (offset === true) {
                    i += index.length;
                } else if (offset) {
                    i += offset;
                }

                $.caretTo(this, i);
            } else {
                $.caretTo(this, index);
            }

            next();
        });
    };

    // Set caret to beginning of an element
    $.fn.caretToStart = function () {
        return this.caretTo(0);
    };

    // Set caret to the end of an element
    $.fn.caretToEnd = function () {
        return this.queue(function (next) {
            $.caretTo(this, $(this).val().length);
            next();
        });
    };

    // Fix bug for old chrome browsers (works on XP)
    const originalFind = $.fn.find;
    $.fn.find = function (selector) {
        if (typeof (selector) === 'string') {
            try {
                return $(this[0].querySelectorAll(selector));
            }
            catch (e) {
                return originalFind.call(this, selector);
            }
        }
        return originalFind.call(this, selector);
    };
}(jQuery));



/*
 * Filter allows only valid text in int/float inputs.
 * testFloat === true: allows decimals with up to two digits after comma
 * testFloat === false: allows integers
 * 
 * params:
 *      maxLength - length limit for input string (including spaces, dots, commas)
 *      maxVal - max value available to input (can be float)
 *      minVal - same but min value (still not sure that this parameter is useful)
 *      allowSpaces(true) - allow triplets separation by spaces
 */
(function ($) {
    $.fn.inputFilter = function (testFloat, params) {
        return this.on("input keydown keyup mousedown mouseup contextmenu drop", function () {
            params = params || {};
            params.allowSpaces = (params.allowSpaces === undefined ? true : params.allowSpaces);

            var simpleVal = this.value.replace(/[^\dр.,\/юб]/g, '')
                .replace(/[р,\/юб]/g, '.') // replace all separators with dot
                .replace(/\.+/g, '.').replace('.', ',').replace(/\./g, '') // remove doubled dots, leave first dot (comma) only
                .replace(/^0+/, '0'); // remove leading zeros

            if (simpleVal[0] === ',') {
                simpleVal = '0' + simpleVal;
            }

            if (simpleVal.length > (params.maxLength || 100)) {
                this.value = this.oldValue || "";
                return;
            }

            var floatMatch = simpleVal.match(/^(-?\d*)([,]?)(\d*)$/);
            var localeVal;
            var precision = params.precision !== undefined ? params.precision : 2;
            if (floatMatch) {
                var floatVal = tools.parseLocaleFloat(floatMatch[0]);
                var roundedFloatVal = tools.roundNumber(floatVal, testFloat ? precision : 0);

                if (testFloat) {
                    if (roundedFloatVal - this.oldRoundedFloatVal < 2 / Math.pow(10, precision) && tools.roundNumber(floatVal, precision, Math.floor) === this.oldRoundedFloatVal) {
                        roundedFloatVal = this.oldRoundedFloatVal;
                    }

                    if (floatMatch[3]) {
                        simpleVal = roundedFloatVal.toFixed(Math.min(precision, floatMatch[3].length)).toString().replace(".", ",");
                    }

                    localeVal = roundedFloatVal === 0 ? simpleVal : tools.getLocaleNumber(roundedFloatVal, { maxPrecision: precision });

                    var simpleValCommaPos = simpleVal.indexOf(',');
                    var localeValCommaPos = localeVal.indexOf(',');

                    if (simpleValCommaPos >= 0) {
                        if (localeValCommaPos >= 0) {
                            var decimalDiff = simpleVal.length - simpleValCommaPos - (localeVal.length - localeValCommaPos);
                            if (simpleVal.length - simpleValCommaPos > localeVal.length - localeValCommaPos) {
                                localeVal += simpleVal.substr(simpleVal.length - decimalDiff);
                            }
                        } else {
                            localeVal += simpleVal.substr(simpleValCommaPos);
                        }
                    }
                } else {
                    if (roundedFloatVal === 0) {
                        localeVal = simpleVal;
                    } else {
                        simpleVal = roundedFloatVal.toFixed(0);
                        localeVal = tools.getLocaleNumber(roundedFloatVal, { maxPrecision: precision});
                    }
                }
            }

            let filterReg;
            if (testFloat) {
                filterReg = new RegExp('^-?\\d*[,]?\\d{0,' + precision + '}$'); 
            }
            else {
                filterReg = /^\d*$/;
            }
            
            if (filterReg.test(simpleVal)) {
                if (event && event.keyCode) {
                    this.prevKeyCode = event.keyCode;
                }

                var newSelectionStart = this.selectionStart;
                var newSelectionEnd = this.selectionEnd;
                var selectionShift = 0;
                
                if ((this.prevKeyCode === 8 || this.prevKeyCode === 46) // 8 - backspace, 46 - delete
                    && this.selectionStart === this.selectionEnd
                    && this.value !== this.oldValue && simpleVal === this.oldSimpleValue) {
                    if (this.prevKeyCode === 8 && this.selectionStart > 0) { // backspace
                        localeVal = localeVal.slice(0, this.selectionStart - 1) + localeVal.slice(this.selectionStart);
                    } else if (this.prevKeyCode === 46) { // delete
                        localeVal = localeVal.slice(0, this.selectionStart + 1) + localeVal.slice(this.selectionStart + 2);
                        selectionShift++;
                    }

                    simpleVal = localeVal.replace(/\s/g, '');
                }

                if (!params.allowSpaces) {
                    localeVal = localeVal.replace(/\s/g, '');
                }

                selectionShift += localeVal.length - this.value.length;
                newSelectionStart = Math.max(0, newSelectionStart + selectionShift);
                newSelectionEnd = Math.max(0, newSelectionEnd + selectionShift);

                var maxVal = params.maxVal || 999999999;
                if ((tools.parseLocaleFloat(simpleVal) > maxVal) ||
                    (!!params.minVal && tools.parseLocaleFloat(simpleVal) < params.minVal)) {
                    this.value = this.oldValue;
                } else {
                    this.value = localeVal;
                    this.oldValue = this.value;
                    this.oldSimpleValue = simpleVal;
                    this.oldRoundedFloatVal = roundedFloatVal;
                    this.oldSelectionStart = newSelectionStart;
                    this.oldSelectionEnd = newSelectionEnd;

                    if (newSelectionStart !== this.selectionStart || newSelectionEnd !== this.selectionEnd) {
                        this.setSelectionRange(newSelectionStart, newSelectionEnd);
                    }
                }
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    };
}(jQuery));


$(function () {
    $(".select.ddc").each(function () { tools.generateDropDown(this); });  //  <- important! it's must be first.
    $("select.ddc").each(function () { tools.transformSelect(this); });
});



export { CalcTools };